import client from '../../../api/apiclient';

const shoppingCart = {
    getGiftMessage: client.createRequestMethod('get', '/api/shoppingcart/GetCartGiftMessage'),
    saveGiftMessage: client.createRequestMethod('post', '/api/shoppingcart/updatecartgiftoption'),
    getCartCostSummary: client.createRequestMethod('get', '/api/shoppingcart/getcartcostsummary'),
    getGuestCustomerRegisterOption: client.createRequestMethod(
        'get',
        '/api/shoppingcart/GetGuestCustomerRegisterOption'
    ),
    getShippingInfoForCart: client.createRequestMethod('get', '/api/shoppingcart/GetShippingInfoForCart'),
    saveGuestCustomerRegisterOption: client.createRequestMethod(
        'post',
        '/api/shoppingcart/SaveGuestCustomerRegisterOption'
    ),
    saveCart: client.createRequestMethod('post', '/api/shoppingcart/submitcart'),
    saveCartWithoutConfirmationEmail: client.createRequestMethod('post', '/api/shoppingcart/secretsubmitcart'),
    getCartItems: client.createRequestMethod('get', '/api/shoppingcart/GetCartItems'),
    moveItemToWishList: client.createRequestMethod('post', '/api/shoppingcart/MoveItemToWishList/'),
    removeWishListItem: client.createConcatRequestMethod('post', '/api/wishlist/removewishlistitem/'),
    addToCartFromWishList: client.createConcatRequestMethod('post', '/api/wishlist/addwishlistitemtocart/'),
    getWishList: client.createRequestMethod('get', '/api/wishlist/getwishlistitems'),
    getCartSamples: client.createRequestMethod('get', '/api/shoppingcart/GetCartSamples'),
    getCartTotals: client.createRequestMethod('get', '/api/shoppingcart/getcarttotals'),
    getShoppingCartModel: client.createRequestMethod('get', '/api/shoppingcart/getshoppingcartmodel'),
    removeItem: client.createConcatRequestMethod('post', '/api/shoppingcart/Remove/'),
    updateQuantityForSupply: client.createRequestMethod('post', '/api/shoppingcart/updatequantityforsupply'),
    updateAutoShip: client.createRequestMethod('post', '/api/shoppingcart/updateautoshipforsupply')
};

export default shoppingCart;